import React from 'react';
import './confirmationDialog.css';

const ConfirmationDialog = ({ open, title, message, onClose, onConfirm }) => {
  if (!open) return null;

  return (
    <div className="modal fade show custom-backdrop" style={{ display: "block" }} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <p>{message}</p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              No
            </button>
            <button type="button" className="btn btn-primary" onClick={onConfirm}>
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
